export const shouldShowHowToUse = (pathname: string) => pathname.includes('/billing-account');
